import Head from "next/head";
import DefaultLayout from "@/components/DefaultLayout";
import SliderBarLeft from "@/components/SliderBarLeft";
import SliderBarRight from "@/components/SliderBarRight";
import styles from "@/styles/article/deliveryBrand.module.scss";

import getConfig from "next/config";
import ArticleTemplate from "@/components/article/ArticleTemplate";
import { usePathname } from "next/navigation";
const { publicRuntimeConfig } = getConfig();
const imageDomain = publicRuntimeConfig.imageDomain;

export default function DeliveryBrand() {
  const pathname = usePathname();
  const articleName = pathname.split("/").pop() || "";

  return (
    <>
      <Head>
        <title>Return Policy - BestDeals.co.nz</title>
      </Head>

      <DefaultLayout>
        <div className={`${styles["page-delivery-brand"]} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <ArticleTemplate
            articleName={articleName}
            banner={`${imageDomain}/delivery-brand/delivery-banner.png`}
          />
        </div>
      </DefaultLayout>
    </>
  );
}
